import cn from "class-names"
import styles from "@components/Listings/ListingsFilter/ListingsFilter.module.scss"
import compStyles from "@css/Components.module.scss"
import Nouislider, { NouisliderProps } from "nouislider-react"
import { rangeMaxValues } from "@components/Listings/ListingsFilter/const"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import React, { useDeferredValue, useEffect, useMemo, useRef, useState } from "react"
import { ElWithSliderApi } from "./types"

const range = {
    min: 20,
    "80%": [300, 5],
    "90%": [600, 5],
    max: 1600
}

export function PointsOnContract() {
    const valueStart = useFilterStore((s) => s.points_on_contract_gte)
    const valueEnd = useFilterStore((s) => s.points_on_contract_lte)
    const onRangeChange = useFilterStore((s) => s.onRangeChange)
    const defRef = useRef([valueStart, valueEnd])
    const [el, setEl] = useState<ElWithSliderApi>(null)
    const deferredValue = useDeferredValue([valueStart, valueEnd])
    useEffect(() => {
        if (el) {
            el.noUiSlider.set(deferredValue, false, true)
        }
    }, [deferredValue, el])
    const onChange = useMemo(() => onRangeChange("points_on_contract", rangeMaxValues.points_on_contract), [onRangeChange])

    const minRef = useRef(null)
    const maxRef = useRef(null)

    const formatter = useMemo<NouisliderProps["tooltips"]>(() => {
        const from = (v: number) => v
        return [
            {
                to: (val: number) => {
                    const result = val > 1500 ? "Max" : Math.round(val)
                    minRef.current.innerText = result
                    return result.toString()
                },
                from
            },
            {
                to: (val: number) => {
                    const result = val > 1500 ? "Max" : Math.round(val)
                    maxRef.current.innerText = result
                    return result.toString()
                },
                from
            }
        ]
    }, [])

    return (
        <div className={cn(styles.filterItem, styles.overPoints, compStyles.sliderWrapper)}>
            <span className={styles.itemTitle}>Points</span>
            <div className={compStyles.sliderSkeleton} style={{ display: el ? "none" : "block" }} />
            <Nouislider instanceRef={setEl as any} onChange={onChange} start={defRef.current} tooltips={formatter} connect step={5} behaviour={"tap-drag"} range={range} />
            <div className={styles.minValue} ref={minRef} />
            <div className={styles.maxValue} ref={maxRef} />
        </div>
    )
}
